(function () {
    'use strict';

    angular
        .module('pointsOfFocusModule', [])
        .controller('SelectPointsOfFocusController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        $scope.selectablePointsOfFocus    = [];
        $scope.selectablePrinciples       = [];
        $scope.groupedSelectedPOF         = [];
        $scope.groupedSelectedPrinciples  = [];
        $scope.selection                  = {};
        $scope.listChanged                = false;

        $scope.$watch('selection.pointOfFocusToAdd', function (selected) {
            if (selected) {
                selectPointOfFocus(selected);
            }
        });

        $scope.removePointOfFocus = function (pointOfFocus) {
            $scope.listChanged = true;
            _.remove($scope.selectedPointsOfFocus, function (pof) {
                return pof.ItemID === pointOfFocus.ItemID;
            });
            $scope.selection.pointOfFocusToAdd = null;
            updateSelectablePointsOfFocus();
        }

        $scope.orderPrinciples = function (groups) {
            return _.sortBy(groups, function(item) {
                return parseInt(item.name);
            });
        }

        function selectPointOfFocus(pointOfFocus) {
            $scope.listChanged = true;
            $scope.selectedPointsOfFocus.push(pointOfFocus);
            $scope.selection.pointOfFocusToAdd = null;
            updateSelectablePointsOfFocus();
        }

        function updateSelectablePointsOfFocus() {
            // Lodash v4 differenceWith would make this code simpler
            // ref: https://lodash.com/docs#differenceWith
            $scope.selectablePointsOfFocus = [];
            _.forEach($scope.allPointsOfFocus, function (pof) {
                var index = _.findIndex($scope.selectedPointsOfFocus, function (selectedPOF) {
                    return selectedPOF.ItemID === pof.ItemID;
                });
                if (index < 0) {
                    $scope.selectablePointsOfFocus.push(pof);
                }
            });

            // Group selected Points of Focus
            $scope.groupedSelectedPOF = _.groupBy($scope.selectedPointsOfFocus, function (pof) {
                return pof.CosoPrincipleTitleEN;
            });
            $scope.groupedSelectedPrinciples = Object.keys($scope.groupedSelectedPOF);
        }

        updateSelectablePointsOfFocus();
    }
})();